import { Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Heading = styled.div`
  width: 100%;
  color: #040222;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
  margin: -20px 0 2px 0;
  span {
    color: #7c47e1;
  }
  z-index: 1
`;

export const Desc = styled.p`
  display: inline;
  font-size: ${(props) => (props.isDesktop ? "14px" : "12px")};
  font-weight: 400;
  line-height: ${(props) => (props.isDesktop ? "20px" : "18px")};
  color: #36354c;
  margin: 0 0 20px;
`;

export const CoverageTable = styled(Flex)`
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid #e7e7f0;
  overflow: hidden;
  z-index: 2;
  position: relative;
`;

export const Row = styled(Flex)`
  width: 100%;
  &:nth-child(1) {
    box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.1);
    background: #fff;
    position: relative;
    z-index: 1;
  }
  &.premium-row {
    border: 1px solid #e7e7f0;
  }
`;

export const CoverageItem = styled(Flex)`
  background: ${(props) => props.background || "white"};
  align-items: center;
  justify-content: center;
  color: #36354c;
  font-size: 12px;
  padding: 1rem 0.5rem;
  border-right: 1px solid #e7e7f0;
  span {
    font-weight: 600;
  }
  #thisYear {
    background: linear-gradient(#f16262, #743ddc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  #lakh-text {
    font-size: 10px !important;
    font-weight: 400
  }
  .section-header {
    padding-top: 24px !important;
  }

  ${(props) =>
    props.isFeature &&
    `
    justify-content: flex-start;
    min-width: 50%;
    padding-left: 12px;
    `}

  ${(props) =>
    props.isTitle &&
    `
    color: #040222;
    font-weight: 500;
    text-align: center;
    `}
`;

export const CoverageTag = styled.div`
  display: inline-flex;
  padding: 2px 16px 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 49px;
  background: linear-gradient(
    91deg,
    rgba(74, 222, 128, 0.32) 0.48%,
    rgba(74, 222, 128, 0) 89.37%
  );
  color: #0a562a;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  white-space: nowrap;
`;

export const DiscountTag = styled.div`
  position: absolute;
  inset: -10px auto auto 50%;
  transform: translateX(-50%);
  background: #c1f5c8;
  color: #0b753e;
  padding: 2px 4px;
  border-radius: 32px;
  border: 1.5px solid #fff;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  overflow-wrap: break-word;
  width: fit-content;
  max-width: 100%;
  z-index: 1;
`;
